import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedDate } from '@dbk/format';
// import Text from '../../../components/common/text';
import Text from '@dbk/ui-text';
import omit from 'lodash/omit';
import { NO_DATA } from '../../../constants';
import { injectIntl } from 'react-intl';

const SimpleDate = (props) => {
  if (props.value && typeof props.value === 'string') {
    return props.month != null || props.month != undefined ? (
      <FormattedDate
        day="2-digit"
        month="long"
        year="numeric"
        value={props.value != null ? new Date(props.value) : NO_DATA}
        {...omit(props, 'value', 'renderProps')}
      >
        {(txt) => (
          <Text type="secondary" size={"large"} style={{ flex: 1 }} {...props.renderProps}>
            {txt}
          </Text>
        )}
      </FormattedDate>
    ) : (
      <FormattedDate
        day="2-digit"
        month="short"
        year="numeric"
        value={props.value != null ? new Date(props.value) : NO_DATA}
        {...omit(props, 'value', 'renderProps')}
      >
        {(txt) => (
          <Text type="secondary" size={"large"} style={{ flex: 1 }} {...props.renderProps} {...omit(props, 'value', 'renderProps')}>
            {txt}
          </Text>
        )}
      </FormattedDate>
    );
  }
  return (
    <div aria-label={props.intl.messages['app.common.nullValue']}>
      <Text type="secondary" size={"large"} {...props.renderProps}>{NO_DATA}</Text>
    </div>
    );
};

SimpleDate.propTypes = {
  ...FormattedDate.PropTypes,
  value: PropTypes.any,
  month: PropTypes.string,
};

SimpleDate.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(SimpleDate));
